import { useSelector } from "react-redux";

import {
  getStoreCustomFooterText,
  getStoreAccessibilityEnabled,
  getStoreIsWhitelabeled,
} from "@selectors/store";
import MinimalFooter from "@stadium/ui/src/components/footer";
import { VISIBLE_LINKS } from "@stadium/ui/src/components/footer/constants";

const Footer = ({ styles }) => {
  const storeIsWhitelabeled = useSelector(getStoreIsWhitelabeled);
  const accessibilityEnabled = useSelector(getStoreAccessibilityEnabled);
  const footerText = useSelector(getStoreCustomFooterText);

  return (
    <MinimalFooter
      storeIsWhitelabeled={storeIsWhitelabeled}
      bannerText="Create a shop for ANY moment"
      displayShopsLogo
      accessibilityEnabled={accessibilityEnabled}
      footerText={footerText}
      visibleLinks={VISIBLE_LINKS}
      leftNavEnabled
      styles={styles}
    />
  );
};

export default Footer;
